import React, { FunctionComponent, useState } from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { MobileDivider } from 'components/UI/MobileDivider';
import { useMasterData } from 'hooks';
import ColorComponent from './ColorComponent';

interface Props {
    color?: string | null;
    onChange: (color: string | null) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            marginBottom: 16
        },
        title: {
            fontSize: 20,
            fontWeight: 600,
            lineHeight: 1.4,
            marginBottom: 6
        },
        description: {
            fontSize: 14,
            lineHeight: '21px',
            color: '#969696',
            marginBottom: 10,
            fontWeight: 400
        },
        colorContainer: {
            gap: 12,
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: 16,
            [theme.breakpoints.up('md')]: {
                maxWidth: 350
            }
        },
        colorBox: {
            marginBottom: 5
        }
    })
);

export const ColorManager: FunctionComponent<Props> = props => {
    const classes = useStyles();
    const masterData = useMasterData();
    const [selectedColor, setSelectedColor] = useState<string | null | undefined>(props.color);

    return (
        <Box className={classes.container}>
            <Typography className={classes.title}>Color Code</Typography>
            <Typography className={classes.description}>Select a color to identify this service.</Typography>
            <Box className={classes.colorContainer}>
                <ColorComponent
                    color="inherit"
                    selected={!selectedColor}
                    onSelect={() => {
                        setSelectedColor(null);
                        props.onChange(null);
                    }}
                />
                {masterData.serviceColors.map(color => (
                    <Box
                        className={classes.colorBox}
                        key={color.id}
                    >
                        <ColorComponent
                            color={color.name}
                            selected={selectedColor === color.id}
                            onSelect={() => {
                                setSelectedColor(color.id);
                                props.onChange(color.id);
                            }}
                        />
                    </Box>
                ))}
            </Box>

            <Box style={{ margin: '0px -16px' }}>
                <MobileDivider />
            </Box>
        </Box>
    );
};

export default ColorManager;
